module.exports = __webpack_public_path__ + "img/20191228125820360截图20191228104104974.a80a30ef.jpg";